import { Card, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { PillsContextualVariations } from "../../../../Constant";
import CommomTagAndPillsCardBody from "../Common/CommomTagAndPillsCardBody";
import { PILLS_CONTEXT, PILLS_DATA } from "../../../../Data/UiKit/BadgesContextualVariations";

const PillsContextualVariationsCart = () => {
  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={PillsContextualVariations} span={PILLS_DATA} />
        <CommomTagAndPillsCardBody data={PILLS_CONTEXT} />
      </Card>
    </Col>
  );
};

export default PillsContextualVariationsCart;